const getTipoAvisoProgramadoList = (state) => {
  return state.tipoAvisoProgramadoList
}

const getDateSelected = (state) => {
  return state.dateSelected
}

const getListAvisosProgramados = (state) => {
  return state.avisosProgramados
}

const getListAvisosAtivos = (state) => {
  return state.avisosAtivos
}

const getListAvisosExpirados7Dias = (state) => {
  return state.avisosExpirados7Dias
}

const getEventSelected = (state) => {
  return state.eventSelected
}

const getEventPublicoAlvo = (state) => {
  return state.eventPublicoAlvo
}

const getAvisos = (state) => {
  return state.avisos
}

export default {
  getTipoAvisoProgramadoList,
  getDateSelected,
  getListAvisosProgramados,
  getListAvisosAtivos,
  getListAvisosExpirados7Dias,
  getEventSelected,
  getEventPublicoAlvo,
  getAvisos
}
